import * as types from '@/store/types'
export default {
    loadMailingGroups: (context, payload) => {
        context.mailingGroups = payload
        context.mailingGroupsLoaded = true
    },
    saveCountsForBot: (context, payload) => {
        context.mailingGroups[0].count = payload.subscribe
        context.mailingGroups[1].count = payload.unsubscribe
    },
    setMailingGroup: (context, payload) => {
        const index = context.mailingGroups.findIndex(item => item.id === payload.id)
        context.mailingGroups[index] = payload
    },
    addMailingGroup: (context, payload) => {
        context.mailingGroups.push(payload)
    },
    removeMailingGroup: (context, id) => {
        const index = context.mailingGroups.findIndex(item => item.id === id)
        context.mailingGroups.splice(index, 1)
    },
    loadClients: (context, payload) => {
        context.clients = payload
    },
    setCountClients: (context, payload) => {
        context.clientsCount = +payload
    },
    addClientsToMailingGroup: (context, payload) => {
        const index = context.mailingGroups.findIndex(item => item.id === +payload.success.data.mailing_group_id)
        if (context.mailingGroups[index] !== undefined) {
            context.mailingGroups[index].count += payload.success.data.countAdded
        }
    },
    removeClientsInMailingGroup: (context, payload) => {
        let index = context.mailingGroups.findIndex(item => item.id === +payload.success.data.mailing_group_id)
        if (context.mailingGroups[index] !== undefined) {
            context.mailingGroups[index].count -= payload.success.data.countRemoved
            for (let i = 0; i < payload.success.data.user_ids.length; i++) {
                index = context.clients.findIndex(mailingGroups => mailingGroups.user_id === payload.success.data.user_ids[i])
                context.clients.splice(index, 1)
                context.clientsCount--
            }
        }
    },
    changeBotIdModelDefault: (context, botId) => {
        context.mailingGroupModelDef.bot_id = botId
    },
    clientUpdate: (context, model) => {
        const index = context.clients.findIndex(item => item.user_id === +model.user_id)
        context.clients[index] = model
    },
    getTree: (context, tree) => {
        context.tree = tree
    },
    getClient: (context, client) => {
        context.clients.push(client)
    }
}
